/**
 * For mobile apps communicate through the venice bridge when certain
 * events happen.
 *
 * @flow
 */

export const isNativeApp = Boolean(
  typeof window !== 'undefined' && window.venice,
)

const isIOS = Boolean(
  typeof window !== 'undefined' &&
    window.navigator &&
    window.navigator.platform &&
    /iPad|iPhone|iPod/.test(navigator.platform),
)

type ShareText = { text: string, url: string }
export function onShareText(obj: ShareText) {
  if (!isNativeApp) return
  if (isIOS) {
    window.venice.shareText(obj)
  } else {
    window.venice.shareText(obj.text)
  }
}

type ProfileOptions = { profilePhotoUrl?: string }
export function onProfileSave({ photoDataURI = '' }: ProfileOptions = {}) {
  if (!isNativeApp) return

  // doesn't seem to exist for IOS at least
  if (!isIOS) {
    window.venice.profileSave()
  }

  // we need to check these methods exist, becuase they don't always...
  if (photoDataURI && isIOS) {
    window.venice.profileImageChanged(photoDataURI)
  }
}

// this is something about resetting the image
// when we don't go through with profile creation
export function onProfileCancel() {
  if (!isNativeApp) return

  // doesn't seem to exist for IOS at least
  if (window.venice.profileCancel) {
    window.venice.profileCancel()
  }
}

export function reAuth() {
  return window.venice.reAuth()
}
